export const GET_DICTIONARY_POINTS = Symbol('GET_DICTIONARY_POINTS');
export const GET_DICTIONARY_POINTS_REQUEST = Symbol('GET_DICTIONARY_POINTS_REQUEST');
export const GET_DICTIONARY_POINTS_SUCCESS = Symbol('GET_DICTIONARY_POINTS_SUCCESS');
export const GET_DICTIONARY_POINTS_ERROR = Symbol('GET_DICTIONARY_POINTS_ERROR');

